import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={37.75}
    height={32.364}
    {...props}
  >
    <defs>
      <style>{".cls-1{fill:#00446e}"}</style>
    </defs>
    <g
      id="Group_685"
      data-name="Group 685"
      transform="translate(-6137.442 -13987)"
    >
      <path
        id="Path_201"
        data-name="Path 201"
        className="cls-1"
        d="M227.059 72.932a3.491 3.491 0 1 1-3.491-3.491 3.491 3.491 0 0 1 3.491 3.491"
        transform="translate(5926.242 13917.559)"
      />
      <path
        id="Path_202"
        data-name="Path 202"
        className="cls-1"
        d="M219.006 188.683a4.527 4.527 0 0 1-2.241-3.922 4.593 4.593 0 0 1 3.965-4.525v-.172a5.913 5.913 0 0 0-5.9-5.9 5.76 5.76 0 0 0-4.266 1.853 4.563 4.563 0 0 1 .129 7.929 7.021 7.021 0 0 1 4.654 6.594v1.121c0-.043.043-.043.043-.086a7.317 7.317 0 0 1 3.62-2.888z"
        transform="translate(5935.028 13820.898)"
      />
      <path
        id="Path_203"
        data-name="Path 203"
        className="cls-1"
        d="M396.179 72.932a3.491 3.491 0 1 1-3.491-3.491 3.491 3.491 0 0 1 3.491 3.491"
        transform="translate(5770.136 13917.559)"
      />
      <path
        id="Path_204"
        data-name="Path 204"
        className="cls-1"
        d="M367.881 183.945a4.563 4.563 0 0 1 .129-7.929 5.884 5.884 0 0 0-10.17 4.051v.129a4.556 4.556 0 0 1 1.767 8.447 6.782 6.782 0 0 1 3.577 2.887v-1.03a6.987 6.987 0 0 1 4.7-6.55z"
        transform="translate(5799.081 13820.896)"
      />
      <path
        id="Path_205"
        data-name="Path 205"
        className="cls-1"
        d="M312.179 270.048a3.491 3.491 0 1 1-3.491-3.491 3.491 3.491 0 0 1 3.491 3.491"
        transform="translate(5847.672 13735.611)"
      />
      <path
        id="Path_206"
        data-name="Path 206"
        className="cls-1"
        d="M279.745 371.84a5.913 5.913 0 0 0-5.9 5.9v1.86a11.738 11.738 0 0 0 5.9 1.336 12.207 12.207 0 0 0 5.9-1.336v-1.853a5.912 5.912 0 0 0-5.9-5.907z"
        transform="translate(5876.616 13638.431)"
      />
      <path
        id="Path_207"
        data-name="Path 207"
        className="cls-1"
        d="M143.059 208.452a3.491 3.491 0 1 1-3.491-3.491 3.491 3.491 0 0 1 3.491 3.491"
        transform="translate(6003.777 13792.468)"
      />
      <path
        id="Path_208"
        data-name="Path 208"
        className="cls-1"
        d="M110.625 310.24a5.913 5.913 0 0 0-5.9 5.9V318a11.738 11.738 0 0 0 5.9 1.336 12.208 12.208 0 0 0 5.9-1.336v-1.853a5.858 5.858 0 0 0-5.9-5.907z"
        transform="translate(6032.721 13695.29)"
      />
      <path
        id="Path_209"
        data-name="Path 209"
        className="cls-1"
        d="M480.179 208.452a3.491 3.491 0 1 1-3.491-3.491 3.491 3.491 0 0 1 3.491 3.491"
        transform="translate(5692.6 13792.468)"
      />
      <path
        id="Path_210"
        data-name="Path 210"
        className="cls-1"
        d="M447.745 310.24a5.913 5.913 0 0 0-5.9 5.9V318a11.738 11.738 0 0 0 5.9 1.336 12.208 12.208 0 0 0 5.9-1.336v-1.853a5.913 5.913 0 0 0-5.9-5.907z"
        transform="translate(5721.544 13695.29)"
      />
    </g>
  </svg>
)

export default SvgComponent
